var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 10.5L3 5.5L13 5.5L8 10.5Z","fill":"currentColor"}));
}

CaretDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
